import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styles from './App.css';
import Header from './components/Header';
import Features from './components/Features';
import Licenses from './components/Licenses';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Text from './components/Text';
import ShoppingCart from './components/ShoppingCart';

function App() {
  return (
    <Router>
      <div className={styles.apps}>
        <div className="Container">

          <Routes>
            {/* Main page route with all sections */}
            <Route path="/" element={
              <>
                <Header />
                <Features />
                <Text />
                <Licenses />
                <Testimonials />
                <Contact />
                <Footer />
              </>
            } />

            {/* ShoppingCart route displays only the ShoppingCart component */}
            <Route path="/cart" element={<ShoppingCart />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
